/**
 * @function evaluate - evaluate docRipperQueryTitleBehavior
 *
 * Retrieve the cached matches (if any) as well as the selected options
 * Format a string indicating selections made or found options
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const {
    importField,
    importFormType
  } = content;
  const [{
    title: formTypeTitle
  }] = Object.values(importFormType);
  const [{
    title: fieldTitle
  }] = Object.values(importField);
  const potentialMatches = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/potentialMatches'
  });
  if (potentialMatches === undefined) {
    return `Retrieve '${fieldTitle}' for all '${formTypeTitle}' assets`;
  }
  return `Found ${Object.keys(potentialMatches).length} '${fieldTitle}' values for all '${formTypeTitle}' assets`;
};
export default {
  evaluate
};